__turbopack_context__.v({
  "divider": "ServiceAccordion-module-scss-module__A7kWbW__divider",
  "serviceAccordionWrapper": "ServiceAccordion-module-scss-module__A7kWbW__serviceAccordionWrapper",
});
